var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_9566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0111 8.8065V4.10547L30.3231 11.157L20.0111 18.2086V13.5075H17.6265C10.7884 13.5075 4.54324 17.0274 1.48833 22.604L0.67627 24.0848C0.67627 15.6465 8.1782 8.8065 17.4332 8.8065H20.0111Z",
    stroke: "#0D4248",
    strokeWidth: 0.825192,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9114 17.2275C22.6835 17.2275 22.4988 17.4123 22.4988 17.6401C22.4988 17.868 22.6835 18.0527 22.9114 18.0527V17.2275ZM26.4561 17.6401H26.8687C26.8687 17.4123 26.684 17.2275 26.4561 17.2275V17.6401ZM26.4561 31.1745V31.5871C26.684 31.5871 26.8687 31.4024 26.8687 31.1745H26.4561ZM0.67627 31.1745H0.263673C0.263673 31.4024 0.448399 31.5871 0.67627 31.5871L0.67627 31.1745ZM22.9114 18.0527H26.4561V17.2275H22.9114V18.0527ZM26.0435 17.6401V31.1745H26.8687V17.6401H26.0435ZM26.4561 30.762H0.67627V31.5871H26.4561V30.762ZM1.08887 31.1745V26.0991H0.263673V31.1745H1.08887Z",
    fill: "#0D4248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12207 17.6401L18.723 17.6401",
    stroke: "#0D4248",
    strokeWidth: 0.644496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.924 28.6297C15.7935 28.6297 17.3152 26.8091 17.3152 24.57C17.3152 22.3309 15.7935 20.5103 13.924 20.5103C12.0544 20.5103 10.5327 22.3309 10.5327 24.57C10.5327 26.8091 12.0544 28.6297 13.924 28.6297ZM13.924 21.3798C15.3098 21.3798 16.4402 22.8091 16.4402 24.57C16.4402 26.3308 15.3098 27.7601 13.924 27.7601C12.5381 27.7601 11.4077 26.3308 11.4077 24.57C11.4077 22.8091 12.5381 21.3798 13.924 21.3798Z",
    fill: "#0D4248"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33419 26.9336C5.02983 26.9336 5.59504 27.4988 5.59504 28.1945C5.59504 28.4336 5.79068 28.6292 6.02981 28.6292H8.98084C9.21997 28.6292 9.41562 28.4336 9.41562 28.1945C9.41562 27.9553 9.21997 27.7597 8.98084 27.7597H6.42111C6.2472 26.9336 5.59504 26.2815 4.76896 26.1076V23.0261C5.59504 22.8522 6.2472 22.2 6.42111 21.3739H8.98084C9.21997 21.3739 9.41562 21.1783 9.41562 20.9392C9.41562 20.7 9.21997 20.5044 8.98084 20.5044H6.02981C5.79068 20.5044 5.59504 20.7 5.59504 20.9392C5.59504 21.6348 5.02983 22.2 4.33419 22.2C4.09506 22.2 3.89941 22.3957 3.89941 22.6348V26.4989C3.89941 26.738 4.09506 26.9336 4.33419 26.9336Z",
    fill: "#0D4248"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4345 27.7543H18.8747C18.6356 27.7543 18.4399 27.95 18.4399 28.1891C18.4399 28.4282 18.6356 28.6239 18.8747 28.6239H21.8258C22.0649 28.6239 22.2605 28.4282 22.2605 28.1891C22.2605 27.4935 22.8257 26.9283 23.5214 26.9283C23.7605 26.9283 23.9561 26.7326 23.9561 26.4935V22.6294C23.9561 22.3903 23.7605 22.1946 23.5214 22.1946C22.8257 22.1946 22.2605 21.6294 22.2605 20.9338C22.2605 20.6947 22.0649 20.499 21.8258 20.499H18.8747C18.6356 20.499 18.4399 20.6947 18.4399 20.9338C18.4399 21.1729 18.6356 21.3686 18.8747 21.3686H21.4345C21.6084 22.1946 22.2605 22.8468 23.0866 23.0207V26.1022C22.2605 26.2761 21.6084 26.9283 21.4345 27.7543Z",
    fill: "#0D4248"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_9566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.9358,
    height: 30.9358,
    fill: "white",
    transform: "translate(0.0322266 0.883301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitIcon3);
export default __webpack_public_path__ + "static/media/benefit-icon3.79700139674348a229f23ec576601174.svg";
export { ForwardRef as ReactComponent };